(function () {
  function closeMenus(except) {
    document.querySelectorAll('.nav-dropdown[open], .mobile-nav[open]').forEach(function (menu) {
      if (menu !== except) menu.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var menu = target.closest('.nav-dropdown, .mobile-nav');
    closeMenus(menu);
    if (menu && target.closest('a')) menu.removeAttribute('open');
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var opened = document.querySelector('.nav-dropdown[open], .mobile-nav[open]');
    if (opened) {
      var summary = opened.querySelector('summary');
      closeMenus();
      if (summary) summary.focus();
    }
  });
})();
